module.exports = __webpack_public_path__ + "static/media/pilotapp2022.79e90eb7.png";